import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { transparentize } from 'polished';
import { css, th, defaultTheme, aliasColor } from '@xstyled/styled-components';
export function primaryColor(color) {
  return aliasColor('primary', color);
}
export var theme = _objectSpread(_objectSpread({
  initialColorModeName: 'light'
}, defaultTheme), {}, {
  global: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    html,\n    body {\n      transition: 300ms ease-in color, 300ms ease-in background-color;\n      margin: 0;\n      font-family: base;\n      background-color: background;\n      color: on-background;\n      line-height: base;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    }\n\n    :focus {\n      outline-color: primary-500;\n    }\n  "]))),
  'prism-theme': function prismTheme() {
    return {
      styles: [{
        types: ['variable', 'constant', 'deleted'],
        style: {
          color: 'rgb(224, 108, 117)'
        }
      }, {
        types: ['punctuation', 'char', 'number'],
        style: {
          color: 'rgb(209, 154, 102)'
        }
      }, {
        types: ['builtin', 'changed', 'namespace', 'class-name', 'tag'],
        style: {
          color: 'rgb(229, 192, 123)'
        }
      }, {
        types: ['operator'],
        style: {
          color: 'rgb(171, 178, 191)'
        }
      }, {
        types: ['inserted', 'string'],
        style: {
          color: 'rgb(152, 195, 121)'
        }
      }, {
        types: ['attr-name', 'comment'],
        style: {
          fontStyle: 'italic'
        }
      }, {
        types: ['function'],
        style: {
          color: 'rgb(97, 175, 239)'
        }
      }, {
        types: ['keyword', 'selector'],
        style: {
          color: 'rgb(198, 120, 221)'
        }
      }, {
        types: ['symbol'],
        style: {
          color: 'rgb(86, 182, 194)'
        }
      }]
    };
  },
  fonts: {
    base: '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif'
  },
  lineHeights: {
    base: 1.4,
    control: th.lineHeight('base')
  },
  transitions: {
    base: '300ms ease all',
    fast: '150ms cubic-bezier(0.215, 0.61, 0.355, 1) all',
    control: th.transition('base')
  },
  radii: {
    base: 4,
    control: th.radius('base'),
    editor: th.radius('base'),
    blockquote: th.radius('base')
  },
  borderWidths: {
    base: 1,
    control: th.borderWidth('base')
  },
  shadows: {
    focus: function focus(p) {
      return "0 0 0 " + th.px(2)(p) + " " + th.color('primary-a500')(p);
    },
    'control-focus': th.shadow('focus')
  },
  sizes: {
    screen: 1440
  },
  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 16,
    4: 24,
    5: 48,
    6: 96,
    7: 144,
    8: 192,
    9: 240,
    'preview-padding-y': 16,
    'preview-padding-x': 24
  },
  colors: _objectSpread(_objectSpread(_objectSpread({}, defaultTheme.colors), aliasColor('primary', 'indigo')), {}, {
    primary: th.color('primary-500'),
    'primary-a500': function primaryA500(p) {
      return transparentize(0.5, th.color('primary-500')(p));
    },
    background: th.color('white'),
    'background-light': th.color('gray-100'),
    'background-primary': th.color('primary-100'),
    'background-mark': th.color('yellow-200'),
    'background-light-a50': function backgroundLightA50(p) {
      return transparentize(0.05, th.color('background-light')(p));
    },
    'on-background': th.color('black'),
    'on-background-light': th.color('gray-700'),
    'on-background-primary': th.color('primary-700'),
    'on-background-primary-dark': th.color('primary-800'),
    'layout-border': th.color('gray-300'),
    'control-background': th.color('gray-100'),
    'control-placeholder': th.color('gray-600'),
    'control-on': th.color('gray-900'),
    'control-border': th.color('layout-border'),
    'control-border-hover': th.color('gray-500'),
    'control-border-active': th.color('primary-400'),
    'editor-background': th.color('gray-900'),
    'editor-on': th.color('gray-100'),
    'editor-border': th.color('layout-border'),
    'blockquote-link': th.color('yellow-800'),
    'blockquote-background': th.color('yellow-200'),
    'blockquote-border': th.color('yellow'),
    'doc-search-suggestion-highlight-background': th.color('primary-200'),
    'doc-search-suggestion-highlight-on-background': th.color('primary-800'),
    'doc-search-suggestion-content-background': th.color('primary-100'),
    'doc-search-suggestion-content-underline': th.color('primary-700'),
    modes: {
      dark: {
        background: th.color('gray-900'),
        'editor-background': th.color('black'),
        'background-light': th.color('gray-800'),
        'background-primary': th.color('primary-900'),
        'background-mark': th.color('yellow-500'),
        'background-light-a50': function backgroundLightA50(p) {
          return transparentize(0.05, th.color('background-light')(p));
        },
        'on-background': th.color('white'),
        'on-background-light': th.color('gray-300'),
        'on-background-primary': th.color('primary-300'),
        'on-background-primary-dark': th.color('primary-200'),
        'layout-border': th.color('gray-700'),
        'control-background': th.color('gray-800'),
        'control-placeholder': th.color('gray-400'),
        'control-on': th.color('gray-100'),
        'control-border': th.color('layout-border'),
        'control-border-hover': th.color('gray-500'),
        'control-border-active': th.color('primary-600'),
        'blockquote-link': th.color('yellow-200'),
        'blockquote-background': th.color('yellow-900'),
        'blockquote-border': th.color('yellow-300'),
        'doc-search-suggestion-highlight-background': th.color('primary-800'),
        'doc-search-suggestion-highlight-on-background': th.color('primary-200'),
        'doc-search-suggestion-content-background': th.color('primary-900'),
        'doc-search-suggestion-content-underline': th.color('primary-300')
      }
    }
  })
});